import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = ["dir"]
const _hoisted_2 = { class: "max-w-6xl mx-auto" }
const _hoisted_3 = { class: "mb-4" }
const _hoisted_4 = {
  class: "relative rounded-2xl p-3 shadow-lg hover:shadow-xl transition-shadow duration-300 overflow-hidden w-full",
  style: {"background":"linear-gradient(135deg, #5856d6 0%, #af52de 100%)","box-shadow":"0 8px 32px rgba(88, 86, 214, 0.3),\n              inset 0 1px 0 rgba(255, 255, 255, 0.2)"}
}
const _hoisted_5 = { class: "relative z-10" }
const _hoisted_6 = { class: "flex items-center justify-between" }
const _hoisted_7 = { class: "flex items-center gap-4" }
const _hoisted_8 = { class: "text-2xl font-bold text-white drop-shadow-sm mb-1" }
const _hoisted_9 = { class: "text-white/80 text-sm font-medium" }
const _hoisted_10 = { class: "lg:grid lg:grid-cols-3 gap-6" }
const _hoisted_11 = { class: "lg:col-span-2" }
const _hoisted_12 = { class: "bg-white dark:bg-[#1a1a1a] rounded-2xl shadow-lg border border-gray-200/50 dark:border-gray-700/50 p-6 mb-6" }
const _hoisted_13 = { class: "flex items-center gap-3 mb-6" }
const _hoisted_14 = { class: "text-lg font-bold text-gray-900 dark:text-white leading-none h-10 flex items-center" }
const _hoisted_15 = {
  key: 0,
  class: "p-4 bg-red-50/80 dark:bg-red-900/20 backdrop-blur-xl rounded-2xl shadow-lg border border-red-200/50 dark:border-red-800/30 mb-6"
}
const _hoisted_16 = { class: "flex items-start gap-4" }
const _hoisted_17 = { class: "text-red-600 dark:text-red-300 mt-1" }
const _hoisted_18 = { class: "grid grid-cols-1 md:grid-cols-2 gap-6" }
const _hoisted_19 = { class: "group" }
const _hoisted_20 = { class: "block text-xs font-semibold text-gray-800 dark:text-gray-200 mb-2 flex items-center gap-2" }
const _hoisted_21 = { class: "relative" }
const _hoisted_22 = ["placeholder"]
const _hoisted_23 = { class: "group" }
const _hoisted_24 = { class: "block text-xs font-semibold text-gray-800 dark:text-gray-200 mb-2 flex items-center gap-2" }
const _hoisted_25 = { class: "relative" }
const _hoisted_26 = { value: "" }
const _hoisted_27 = { value: "Digital Product" }
const _hoisted_28 = { value: "Physical Product" }
const _hoisted_29 = { value: "Service" }
const _hoisted_30 = { class: "group" }
const _hoisted_31 = { class: "block text-xs font-semibold text-gray-800 dark:text-gray-200 mb-2 flex items-center gap-2" }
const _hoisted_32 = { class: "relative" }
const _hoisted_33 = ["placeholder"]
const _hoisted_34 = { class: "group" }
const _hoisted_35 = { class: "block text-xs font-semibold text-gray-800 dark:text-gray-200 mb-2 flex items-center gap-2" }
const _hoisted_36 = { class: "relative" }
const _hoisted_37 = ["placeholder"]
const _hoisted_38 = { class: "text-xs text-gray-500 dark:text-gray-400 mt-2 flex items-center gap-1" }
const _hoisted_39 = { class: "md:col-span-2 group" }
const _hoisted_40 = { class: "block text-xs font-semibold text-gray-800 dark:text-gray-200 mb-2 flex items-center gap-2" }
const _hoisted_41 = { class: "relative" }
const _hoisted_42 = ["placeholder"]
const _hoisted_43 = { class: "group" }
const _hoisted_44 = { class: "block text-xs font-semibold text-gray-800 dark:text-gray-200 mb-2 flex items-center gap-2" }
const _hoisted_45 = { class: "relative" }
const _hoisted_46 = ["placeholder"]
const _hoisted_47 = { class: "group" }
const _hoisted_48 = { class: "block text-xs font-semibold text-gray-800 dark:text-gray-200 mb-2 flex items-center gap-2" }
const _hoisted_49 = { class: "relative" }
const _hoisted_50 = ["placeholder"]
const _hoisted_51 = { class: "group" }
const _hoisted_52 = { class: "block text-xs font-semibold text-gray-800 dark:text-gray-200 mb-2 flex items-center gap-2" }
const _hoisted_53 = { class: "relative" }
const _hoisted_54 = ["placeholder"]
const _hoisted_55 = { class: "md:col-span-2 group" }
const _hoisted_56 = { class: "block text-xs font-semibold text-gray-800 dark:text-gray-200 mb-2 flex items-center gap-2" }
const _hoisted_57 = { class: "flex items-start gap-6" }
const _hoisted_58 = {
  key: 0,
  class: "flex-shrink-0"
}
const _hoisted_59 = { class: "w-32 h-32 rounded-2xl overflow-hidden shadow-lg border-2 border-gray-200 dark:border-gray-600" }
const _hoisted_60 = ["src"]
const _hoisted_61 = { class: "flex-1" }
const _hoisted_62 = { class: "relative" }
const _hoisted_63 = { class: "border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-2xl p-8 text-center hover:border-purple-400 dark:hover:border-purple-500 transition-colors duration-200 bg-gray-50/50 dark:bg-gray-800/50 backdrop-blur-sm" }
const _hoisted_64 = { class: "flex flex-col items-center gap-4" }
const _hoisted_65 = { class: "text-lg font-semibold text-gray-900 dark:text-white mb-1" }
const _hoisted_66 = { class: "text-sm text-gray-500 dark:text-gray-400" }
const _hoisted_67 = {
  key: 0,
  class: "mt-4 flex items-center gap-2"
}
const _hoisted_68 = {
  key: 0,
  class: "flex items-center gap-2 text-blue-600 dark:text-blue-400"
}
const _hoisted_69 = { class: "text-sm font-medium" }
const _hoisted_70 = {
  key: 1,
  class: "flex items-center gap-2 text-green-600 dark:text-green-400"
}
const _hoisted_71 = { class: "text-sm font-medium" }
const _hoisted_72 = {
  key: 2,
  class: "flex items-center gap-2 text-red-600 dark:text-red-400"
}
const _hoisted_73 = { class: "text-sm font-medium" }
const _hoisted_74 = {
  key: 0,
  class: "bg-white dark:bg-[#1a1a1a] rounded-2xl shadow-lg border border-gray-200/50 dark:border-gray-700/50 p-6 mb-6"
}
const _hoisted_75 = { class: "flex items-center justify-between mb-6" }
const _hoisted_76 = { class: "flex items-center gap-3" }
const _hoisted_77 = { class: "text-lg font-bold text-gray-900 dark:text-white leading-none h-10 flex items-center" }
const _hoisted_78 = ["title"]
const _hoisted_79 = { class: "text-xs font-medium text-red-700 dark:text-red-300" }
const _hoisted_80 = { class: "space-y-8" }
const _hoisted_81 = { class: "flex items-center justify-between mb-6" }
const _hoisted_82 = { class: "flex items-center gap-3" }
const _hoisted_83 = { class: "text-md font-semibold text-gray-800 dark:text-gray-200" }
const _hoisted_84 = ["onClick", "title"]
const _hoisted_85 = { class: "group mb-6" }
const _hoisted_86 = { class: "block text-xs font-semibold text-gray-800 dark:text-gray-200 mb-2 flex items-center gap-2" }
const _hoisted_87 = { class: "relative" }
const _hoisted_88 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_89 = { class: "space-y-4" }
const _hoisted_90 = { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" }
const _hoisted_91 = { class: "group" }
const _hoisted_92 = { class: "block text-xs font-semibold text-gray-800 dark:text-gray-200 mb-2 flex items-center gap-2" }
const _hoisted_93 = { class: "relative" }
const _hoisted_94 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_95 = { class: "group" }
const _hoisted_96 = { class: "block text-xs font-semibold text-gray-800 dark:text-gray-200 mb-2 flex items-center gap-2" }
const _hoisted_97 = { class: "relative" }
const _hoisted_98 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_99 = { class: "group" }
const _hoisted_100 = { class: "block text-xs font-semibold text-gray-800 dark:text-gray-200 mb-2 flex items-center gap-2" }
const _hoisted_101 = { class: "relative" }
const _hoisted_102 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_103 = { class: "group" }
const _hoisted_104 = { class: "block text-xs font-semibold text-gray-800 dark:text-gray-200 mb-2 flex items-center gap-2" }
const _hoisted_105 = { class: "flex items-center gap-3" }
const _hoisted_106 = {
  key: 0,
  class: "flex-shrink-0"
}
const _hoisted_107 = { class: "w-16 h-16 rounded-xl overflow-hidden shadow-lg border-2 border-gray-200 dark:border-gray-600" }
const _hoisted_108 = ["src"]
const _hoisted_109 = { class: "flex-1" }
const _hoisted_110 = { class: "relative" }
const _hoisted_111 = { class: "border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-xl p-3 text-center hover:border-purple-400 dark:hover:border-purple-500 transition-colors duration-200 bg-white dark:bg-gray-800" }
const _hoisted_112 = { class: "flex items-center justify-center gap-2" }
const _hoisted_113 = { class: "text-sm font-medium text-gray-700 dark:text-gray-300" }
const _hoisted_114 = ["onChange"]
const _hoisted_115 = ["onClick"]
const _hoisted_116 = ["onClick"]
const _hoisted_117 = { class: "text-sm font-medium text-blue-700 dark:text-blue-300" }
const _hoisted_118 = {
  key: 1,
  class: "bg-white dark:bg-[#1a1a1a] rounded-2xl shadow-lg border border-gray-200/50 dark:border-gray-700/50 p-6 mb-6"
}
const _hoisted_119 = { class: "flex items-center justify-between mb-6" }
const _hoisted_120 = { class: "flex items-center gap-3" }
const _hoisted_121 = { class: "text-lg font-bold text-gray-900 dark:text-white leading-none h-10 flex items-center" }
const _hoisted_122 = { class: "mb-6" }
const _hoisted_123 = { class: "block text-sm font-semibold text-gray-900 dark:text-white mb-2" }
const _hoisted_124 = ["placeholder"]
const _hoisted_125 = {
  key: 0,
  class: "mb-6"
}
const _hoisted_126 = { class: "text-sm font-semibold text-gray-900 dark:text-white mb-4 flex items-center gap-2" }
const _hoisted_127 = { class: "grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3" }
const _hoisted_128 = ["onClick"]
const _hoisted_129 = {
  class: "w-8 h-8 rounded-lg flex items-center justify-center transition-colors",
  style: {"background-color":"#ffffff","color":"#6b7280"}
}
const _hoisted_130 = { class: "material-symbols-outlined text-sm" }
const _hoisted_131 = { class: "text-xs font-medium text-center" }
const _hoisted_132 = {
  key: 1,
  class: "mb-6 bg-gradient-to-br from-blue-50 to-indigo-50 dark:from-blue-900/20 dark:to-indigo-900/20 border border-blue-200 dark:border-blue-700/50 rounded-xl p-6"
}
const _hoisted_133 = { class: "flex items-center justify-between mb-4" }
const _hoisted_134 = { class: "flex items-center gap-3" }
const _hoisted_135 = {
  class: "w-10 h-10 rounded-xl flex items-center justify-center",
  style: {"background":"linear-gradient(135deg, #5856d6 0%, #af52de 100%)"}
}
const _hoisted_136 = { class: "material-symbols-outlined text-white text-lg" }
const _hoisted_137 = { class: "text-lg font-bold text-gray-900 dark:text-white" }
const _hoisted_138 = { class: "space-y-4" }
const _hoisted_139 = { class: "block text-sm font-semibold text-gray-900 dark:text-white mb-2" }
const _hoisted_140 = ["placeholder"]
const _hoisted_141 = { class: "block text-sm font-semibold text-gray-900 dark:text-white mb-2" }
const _hoisted_142 = ["placeholder"]
const _hoisted_143 = { class: "flex items-center gap-3" }
const _hoisted_144 = {
  for: "fieldRequired",
  class: "text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_145 = {
  key: 0,
  class: "space-y-3"
}
const _hoisted_146 = { class: "block text-sm font-semibold text-gray-900 dark:text-white" }
const _hoisted_147 = { class: "space-y-2" }
const _hoisted_148 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_149 = ["onClick"]
const _hoisted_150 = { class: "text-sm font-medium" }
const _hoisted_151 = { class: "flex items-center justify-between pt-4" }
const _hoisted_152 = {
  key: 2,
  class: "mb-6"
}
const _hoisted_153 = { class: "text-sm font-semibold text-gray-900 dark:text-white mb-4 flex items-center gap-2" }
const _hoisted_154 = { class: "space-y-3" }
const _hoisted_155 = { class: "flex items-center justify-between" }
const _hoisted_156 = { class: "flex items-center gap-3" }
const _hoisted_157 = { class: "w-8 h-8 bg-blue-100 dark:bg-blue-900/30 rounded-lg flex items-center justify-center" }
const _hoisted_158 = { class: "material-symbols-outlined text-blue-600 dark:text-blue-400 text-sm" }
const _hoisted_159 = { class: "text-sm font-medium text-gray-900 dark:text-white" }
const _hoisted_160 = { class: "text-xs text-gray-500 dark:text-gray-400" }
const _hoisted_161 = ["onClick"]
const _hoisted_162 = { class: "lg:col-span-1" }
const _hoisted_163 = { class: "bg-white dark:bg-[#1a1a1a] rounded-2xl shadow-lg border border-gray-200/50 dark:border-gray-700/50 p-6" }
const _hoisted_164 = { class: "flex items-center gap-3 mb-6" }
const _hoisted_165 = { class: "text-lg font-bold text-gray-900 dark:text-white leading-none h-10 flex items-center" }
const _hoisted_166 = { class: "space-y-4" }
const _hoisted_167 = { class: "group" }
const _hoisted_168 = { class: "block text-xs font-semibold text-gray-800 dark:text-gray-200 mb-2 flex items-center gap-2" }
const _hoisted_169 = { class: "relative" }
const _hoisted_170 = ["placeholder"]
const _hoisted_171 = { class: "text-xs text-gray-500 dark:text-gray-400 mt-2 flex items-center gap-1" }
const _hoisted_172 = {
  key: 0,
  class: "space-y-3"
}
const _hoisted_173 = { class: "text-sm font-semibold text-gray-700 dark:text-gray-300 flex items-center gap-2" }
const _hoisted_174 = { class: "flex flex-wrap gap-2" }
const _hoisted_175 = ["onClick", "title"]
const _hoisted_176 = { class: "bg-white dark:bg-[#1a1a1a] rounded-2xl shadow-lg border border-gray-200/50 dark:border-gray-700/50 p-6 mt-6" }
const _hoisted_177 = { class: "space-y-3" }
const _hoisted_178 = { class: "text-sm font-medium text-blue-700 dark:text-blue-300" }
const _hoisted_179 = { class: "text-sm font-medium text-green-700 dark:text-green-300" }
const _hoisted_180 = { class: "text-sm font-medium text-purple-700 dark:text-purple-300" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "min-h-screen bg-white dark:bg-[#0c1427] p-3",
    dir: _ctx.isRtl ? 'rtl' : 'ltr'
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[37] || (_cache[37] = _createElementVNode("div", { class: "absolute inset-0 overflow-hidden" }, [
            _createElementVNode("div", {
              class: "absolute -top-20 -right-20 w-40 h-40 rounded-full opacity-20",
              style: {"background":"radial-gradient(\n                  circle,\n                  rgba(255, 255, 255, 0.3) 0%,\n                  transparent 70%\n                )"}
            }),
            _createElementVNode("div", {
              class: "absolute -bottom-16 -left-16 w-32 h-32 rounded-full opacity-15",
              style: {"background":"radial-gradient(\n                  circle,\n                  rgba(255, 255, 255, 0.4) 0%,\n                  transparent 70%\n                )"}
            })
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[36] || (_cache[36] = _createElementVNode("div", { class: "relative flex-shrink-0" }, [
                  _createElementVNode("div", { class: "w-20 h-20 rounded-full bg-white/20 backdrop-blur-sm border-3 border-white/70 shadow-xl flex items-center justify-center" }, [
                    _createElementVNode("i", { class: "material-symbols-outlined text-white text-3xl" }, "inventory_2")
                  ])
                ], -1)),
                _createElementVNode("div", null, [
                  _createElementVNode("h1", _hoisted_8, _toDisplayString(_ctx.directT('ecommerce.createProduct.addProduct')), 1),
                  _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.directT('ecommerce.createProduct.subtitle') || 'צור מוצר חדש במערכת'), 1)
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("form", null, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _cache[38] || (_cache[38] = _createElementVNode("div", { class: "w-10 h-10 bg-gradient-to-br from-[#5856d6] to-[#af52de] rounded-xl flex items-center justify-center" }, [
                  _createElementVNode("i", { class: "material-symbols-outlined text-white text-lg" }, "info")
                ], -1)),
                _createElementVNode("h3", _hoisted_14, _toDisplayString(_ctx.directT('ecommerce.createProduct.productInformation') || 'מידע מוצר'), 1)
              ]),
              (_ctx.error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _cache[40] || (_cache[40] = _createElementVNode("div", { class: "w-10 h-10 bg-red-500/10 rounded-xl flex items-center justify-center" }, [
                        _createElementVNode("i", { class: "material-symbols-outlined text-red-500 text-xl" }, "error")
                      ], -1)),
                      _createElementVNode("div", null, [
                        _cache[39] || (_cache[39] = _createElementVNode("h3", { class: "text-lg font-semibold text-red-700 dark:text-red-400" }, "שגיאה", -1)),
                        _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.error), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("label", _hoisted_20, [
                    _cache[41] || (_cache[41] = _createElementVNode("i", { class: "material-symbols-outlined text-purple-600 text-sm" }, "title", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.directT('ecommerce.createProduct.productTitle')) + " ", 1),
                    _cache[42] || (_cache[42] = _createElementVNode("span", { class: "text-red-500" }, "*", -1))
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.product.title) = $event)),
                      placeholder: _ctx.directT('ecommerce.createProduct.productTitlePlaceholder'),
                      class: "w-full px-4 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm bg-white/80 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400"
                    }, null, 8, _hoisted_22), [
                      [_vModelText, _ctx.product.title]
                    ]),
                    _cache[43] || (_cache[43] = _createElementVNode("div", { class: "absolute right-3 top-1/2 -translate-y-1/2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined text-gray-400 text-sm" }, "edit")
                    ], -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("label", _hoisted_24, [
                    _cache[44] || (_cache[44] = _createElementVNode("i", { class: "material-symbols-outlined text-purple-600 text-sm" }, "category", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.directT('ecommerce.createProduct.productType')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.product.product_type) = $event)),
                      class: "w-full px-4 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm bg-white/80 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md text-gray-900 dark:text-white cursor-pointer appearance-none"
                    }, [
                      _createElementVNode("option", _hoisted_26, _toDisplayString(_ctx.directT('ecommerce.createProduct.selectType')), 1),
                      _createElementVNode("option", _hoisted_27, _toDisplayString(_ctx.directT('ecommerce.createProduct.digitalProduct')), 1),
                      _createElementVNode("option", _hoisted_28, _toDisplayString(_ctx.directT('ecommerce.createProduct.physicalProduct')), 1),
                      _createElementVNode("option", _hoisted_29, _toDisplayString(_ctx.directT('ecommerce.createProduct.service')), 1)
                    ], 512), [
                      [_vModelSelect, _ctx.product.product_type]
                    ]),
                    _cache[45] || (_cache[45] = _createElementVNode("div", { class: "absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined text-gray-400 text-sm" }, "expand_more")
                    ], -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("label", _hoisted_31, [
                    _cache[46] || (_cache[46] = _createElementVNode("i", { class: "material-symbols-outlined text-purple-600 text-sm" }, "label", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.directT('ecommerce.createProduct.category')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.product.category) = $event)),
                      placeholder: _ctx.directT('ecommerce.createProduct.categoryPlaceholder'),
                      class: "w-full px-4 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm bg-white/80 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400"
                    }, null, 8, _hoisted_33), [
                      [_vModelText, _ctx.product.category]
                    ]),
                    _cache[47] || (_cache[47] = _createElementVNode("div", { class: "absolute right-3 top-1/2 -translate-y-1/2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined text-gray-400 text-sm" }, "edit")
                    ], -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("label", _hoisted_35, [
                    _cache[48] || (_cache[48] = _createElementVNode("i", { class: "material-symbols-outlined text-purple-600 text-sm" }, "inventory", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.directT('ecommerce.createProduct.stockAmount')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.product.stock_amount) = $event)),
                      placeholder: _ctx.directT('ecommerce.createProduct.stockAmountPlaceholder'),
                      class: "w-full px-4 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm bg-white/80 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400"
                    }, null, 8, _hoisted_37), [
                      [_vModelText, _ctx.product.stock_amount]
                    ]),
                    _cache[49] || (_cache[49] = _createElementVNode("div", { class: "absolute right-3 top-1/2 -translate-y-1/2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined text-gray-400 text-sm" }, "inventory_2")
                    ], -1))
                  ]),
                  _createElementVNode("p", _hoisted_38, [
                    _cache[50] || (_cache[50] = _createElementVNode("i", { class: "material-symbols-outlined text-xs" }, "info", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.directT('ecommerce.createProduct.stockAmountHint')), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("label", _hoisted_40, [
                    _cache[51] || (_cache[51] = _createElementVNode("i", { class: "material-symbols-outlined text-purple-600 text-sm" }, "description", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.directT('ecommerce.createProduct.description')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_41, [
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.product.description) = $event)),
                      rows: "4",
                      class: "w-full px-4 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm bg-white/80 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 resize-none",
                      placeholder: _ctx.directT('ecommerce.createProduct.descriptionPlaceholder') || 'תיאור המוצר...'
                    }, null, 8, _hoisted_42), [
                      [_vModelText, _ctx.product.description]
                    ]),
                    _cache[52] || (_cache[52] = _createElementVNode("div", { class: "absolute right-3 top-3" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined text-gray-400 text-sm" }, "edit")
                    ], -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("label", _hoisted_44, [
                    _cache[53] || (_cache[53] = _createElementVNode("i", { class: "material-symbols-outlined text-purple-600 text-sm" }, "payments", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.directT('ecommerce.createProduct.regularPrice')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_45, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.product.price) = $event)),
                      placeholder: _ctx.directT('ecommerce.createProduct.regularPricePlaceholder'),
                      class: "w-full px-4 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm bg-white/80 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400"
                    }, null, 8, _hoisted_46), [
                      [_vModelText, _ctx.product.price]
                    ]),
                    _cache[54] || (_cache[54] = _createElementVNode("div", { class: "absolute right-3 top-1/2 -translate-y-1/2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined text-gray-400 text-sm" }, "attach_money")
                    ], -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("label", _hoisted_48, [
                    _cache[55] || (_cache[55] = _createElementVNode("i", { class: "material-symbols-outlined text-purple-600 text-sm" }, "local_offer", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.directT('ecommerce.createProduct.salePrice')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_49, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.product.compare_at_price) = $event)),
                      placeholder: _ctx.directT('ecommerce.createProduct.salePricePlaceholder'),
                      class: "w-full px-4 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm bg-white/80 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400"
                    }, null, 8, _hoisted_50), [
                      [_vModelText, _ctx.product.compare_at_price]
                    ]),
                    _cache[56] || (_cache[56] = _createElementVNode("div", { class: "absolute right-3 top-1/2 -translate-y-1/2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined text-gray-400 text-sm" }, "sell")
                    ], -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("label", _hoisted_52, [
                    _cache[57] || (_cache[57] = _createElementVNode("i", { class: "material-symbols-outlined text-purple-600 text-sm" }, "link", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.directT('ecommerce.createProduct.productLink')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_53, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.product.product_link) = $event)),
                      placeholder: _ctx.directT('ecommerce.createProduct.productLinkPlaceholder'),
                      class: "w-full px-4 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm bg-white/80 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400"
                    }, null, 8, _hoisted_54), [
                      [_vModelText, _ctx.product.product_link]
                    ]),
                    _cache[58] || (_cache[58] = _createElementVNode("div", { class: "absolute right-3 top-1/2 -translate-y-1/2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined text-gray-400 text-sm" }, "open_in_new")
                    ], -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("label", _hoisted_56, [
                    _cache[59] || (_cache[59] = _createElementVNode("i", { class: "material-symbols-outlined text-purple-600 text-sm" }, "image", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.directT('ecommerce.createProduct.productImage')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_57, [
                    (_ctx.product.image_link)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                          _createElementVNode("div", _hoisted_59, [
                            _createElementVNode("img", {
                              src: _ctx.product.image_link,
                              alt: "Product image",
                              class: "w-full h-full object-cover"
                            }, null, 8, _hoisted_60)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_61, [
                      _createElementVNode("div", _hoisted_62, [
                        _createElementVNode("div", _hoisted_63, [
                          _createElementVNode("div", _hoisted_64, [
                            _cache[60] || (_cache[60] = _createElementVNode("div", { class: "w-16 h-16 bg-gradient-to-br from-[#5856d6] to-[#af52de] rounded-2xl flex items-center justify-center shadow-lg" }, [
                              _createElementVNode("i", { class: "material-symbols-outlined text-white text-2xl" }, "cloud_upload")
                            ], -1)),
                            _createElementVNode("div", null, [
                              _createElementVNode("p", _hoisted_65, _toDisplayString(_ctx.directT('ecommerce.createProduct.clickToUpload')), 1),
                              _createElementVNode("p", _hoisted_66, _toDisplayString(_ctx.directT('ecommerce.createProduct.image') || 'PNG, JPG, GIF עד 10MB'), 1)
                            ])
                          ]),
                          _createElementVNode("input", {
                            type: "file",
                            id: "fileInput",
                            class: "absolute inset-0 w-full h-full opacity-0 cursor-pointer",
                            onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.handleFileUpload && _ctx.handleFileUpload(...args))),
                            accept: "image/*"
                          }, null, 32)
                        ])
                      ]),
                      (_ctx.uploadStatus)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                            (_ctx.uploadStatus === 'uploading')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                                  _cache[61] || (_cache[61] = _createElementVNode("div", { class: "w-4 h-4 border-2 border-blue-600 border-t-transparent rounded-full animate-spin" }, null, -1)),
                                  _createElementVNode("span", _hoisted_69, _toDisplayString(_ctx.directT('ecommerce.createProduct.uploading')), 1)
                                ]))
                              : (_ctx.uploadStatus === 'success')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                                    _cache[62] || (_cache[62] = _createElementVNode("i", { class: "material-symbols-outlined text-sm" }, "check_circle", -1)),
                                    _createElementVNode("span", _hoisted_71, _toDisplayString(_ctx.directT('ecommerce.createProduct.uploadSuccess')), 1)
                                  ]))
                                : (_ctx.uploadStatus === 'error')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                                      _cache[63] || (_cache[63] = _createElementVNode("i", { class: "material-symbols-outlined text-sm" }, "error", -1)),
                                      _createElementVNode("span", _hoisted_73, _toDisplayString(_ctx.directT('ecommerce.createProduct.uploadFailed')), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ]),
            (_ctx.showVariations)
              ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                  _createElementVNode("div", _hoisted_75, [
                    _createElementVNode("div", _hoisted_76, [
                      _cache[64] || (_cache[64] = _createElementVNode("div", { class: "w-10 h-10 bg-gradient-to-br from-[#5856d6] to-[#af52de] rounded-xl flex items-center justify-center" }, [
                        _createElementVNode("i", { class: "material-symbols-outlined text-white text-lg" }, "tune")
                      ], -1)),
                      _createElementVNode("h3", _hoisted_77, _toDisplayString(_ctx.directT('ecommerce.createProduct.productVariations')), 1)
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.removeVariationsCard && _ctx.removeVariationsCard(...args))),
                      class: "flex items-center gap-2 px-3 py-2 bg-red-50 dark:bg-red-900/20 hover:bg-red-100 dark:hover:bg-red-900/30 border border-red-200 dark:border-red-700/50 rounded-xl transition-all duration-200 shadow-sm hover:shadow-md group",
                      title: _ctx.directT('ecommerce.createProduct.removeVariationsCard')
                    }, [
                      _cache[65] || (_cache[65] = _createElementVNode("i", { class: "material-symbols-outlined text-red-600 dark:text-red-400 text-sm group-hover:scale-110 transition-transform" }, "delete", -1)),
                      _createElementVNode("span", _hoisted_79, _toDisplayString(_ctx.directT('ecommerce.createProduct.removeCard')), 1)
                    ], 8, _hoisted_78)
                  ]),
                  _createElementVNode("div", _hoisted_80, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.variationGroups, (group, groupIndex) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: groupIndex,
                        class: "border-2 border-gray-200 dark:border-gray-600 rounded-2xl p-6 bg-gradient-to-br from-gray-50/50 to-white dark:from-gray-800/50 dark:to-gray-900/50"
                      }, [
                        _createElementVNode("div", _hoisted_81, [
                          _createElementVNode("div", _hoisted_82, [
                            _cache[66] || (_cache[66] = _createElementVNode("div", { class: "w-8 h-8 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-lg flex items-center justify-center" }, [
                              _createElementVNode("i", { class: "material-symbols-outlined text-white text-sm" }, "category")
                            ], -1)),
                            _createElementVNode("h4", _hoisted_83, _toDisplayString(_ctx.directT('ecommerce.createProduct.variationGroup')) + " " + _toDisplayString(groupIndex + 1), 1)
                          ]),
                          _createElementVNode("button", {
                            type: "button",
                            onClick: ($event: any) => (_ctx.removeVariationGroup(groupIndex)),
                            class: "flex items-center gap-1 px-2 py-1 bg-red-50 dark:bg-red-900/20 hover:bg-red-100 dark:hover:bg-red-900/30 border border-red-200 dark:border-red-700/50 rounded-lg transition-all duration-200 group",
                            title: _ctx.directT('ecommerce.createProduct.removeVariationGroup')
                          }, _cache[67] || (_cache[67] = [
                            _createElementVNode("i", { class: "material-symbols-outlined text-red-600 dark:text-red-400 text-xs group-hover:scale-110 transition-transform" }, "close", -1)
                          ]), 8, _hoisted_84)
                        ]),
                        _createElementVNode("div", _hoisted_85, [
                          _createElementVNode("label", _hoisted_86, [
                            _cache[68] || (_cache[68] = _createElementVNode("i", { class: "material-symbols-outlined text-purple-600 text-sm" }, "label", -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.directT('ecommerce.createProduct.variationName')), 1)
                          ]),
                          _createElementVNode("div", _hoisted_87, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": ($event: any) => ((group.name) = $event),
                              placeholder: _ctx.directT('ecommerce.createProduct.variationNamePlaceholder'),
                              class: "w-full px-4 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm bg-white/80 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400"
                            }, null, 8, _hoisted_88), [
                              [_vModelText, group.name]
                            ]),
                            _cache[69] || (_cache[69] = _createElementVNode("div", { class: "absolute right-3 top-1/2 -translate-y-1/2" }, [
                              _createElementVNode("i", { class: "material-symbols-outlined text-gray-400 text-sm" }, "edit")
                            ], -1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_89, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.rows, (row, rowIndex) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: rowIndex,
                              class: "border border-gray-200 dark:border-gray-600 rounded-xl p-4 bg-white/70 dark:bg-gray-800/70"
                            }, [
                              _createElementVNode("div", _hoisted_90, [
                                _createElementVNode("div", _hoisted_91, [
                                  _createElementVNode("label", _hoisted_92, [
                                    _cache[70] || (_cache[70] = _createElementVNode("i", { class: "material-symbols-outlined text-purple-600 text-sm" }, "text_fields", -1)),
                                    _createTextVNode(" " + _toDisplayString(_ctx.directT('ecommerce.createProduct.variation')), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_93, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "text",
                                      "onUpdate:modelValue": ($event: any) => ((row.text) = $event),
                                      placeholder: _ctx.directT('ecommerce.createProduct.variationPlaceholder'),
                                      class: "w-full px-4 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm bg-white/80 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400"
                                    }, null, 8, _hoisted_94), [
                                      [_vModelText, row.text]
                                    ]),
                                    _cache[71] || (_cache[71] = _createElementVNode("div", { class: "absolute right-3 top-1/2 -translate-y-1/2" }, [
                                      _createElementVNode("i", { class: "material-symbols-outlined text-gray-400 text-sm" }, "edit")
                                    ], -1))
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_95, [
                                  _createElementVNode("label", _hoisted_96, [
                                    _cache[72] || (_cache[72] = _createElementVNode("i", { class: "material-symbols-outlined text-purple-600 text-sm" }, "attach_money", -1)),
                                    _createTextVNode(" " + _toDisplayString(_ctx.directT('ecommerce.createProduct.price')), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_97, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "number",
                                      step: "0.01",
                                      "onUpdate:modelValue": ($event: any) => ((row.price) = $event),
                                      placeholder: _ctx.directT('ecommerce.createProduct.pricePlaceholder'),
                                      class: "w-full px-4 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm bg-white/80 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400"
                                    }, null, 8, _hoisted_98), [
                                      [_vModelText, row.price]
                                    ]),
                                    _cache[73] || (_cache[73] = _createElementVNode("div", { class: "absolute right-3 top-1/2 -translate-y-1/2" }, [
                                      _createElementVNode("i", { class: "material-symbols-outlined text-gray-400 text-sm" }, "attach_money")
                                    ], -1))
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_99, [
                                  _createElementVNode("label", _hoisted_100, [
                                    _cache[74] || (_cache[74] = _createElementVNode("i", { class: "material-symbols-outlined text-purple-600 text-sm" }, "local_offer", -1)),
                                    _createTextVNode(" " + _toDisplayString(_ctx.directT('ecommerce.createProduct.compareAtPrice')), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_101, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "number",
                                      step: "0.01",
                                      "onUpdate:modelValue": ($event: any) => ((row.compare_at_price) = $event),
                                      placeholder: _ctx.directT('ecommerce.createProduct.compareAtPricePlaceholder'),
                                      class: "w-full px-4 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm bg-white/80 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400"
                                    }, null, 8, _hoisted_102), [
                                      [_vModelText, row.compare_at_price]
                                    ]),
                                    _cache[75] || (_cache[75] = _createElementVNode("div", { class: "absolute right-3 top-1/2 -translate-y-1/2" }, [
                                      _createElementVNode("i", { class: "material-symbols-outlined text-gray-400 text-sm" }, "local_offer")
                                    ], -1))
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_103, [
                                  _createElementVNode("label", _hoisted_104, [
                                    _cache[76] || (_cache[76] = _createElementVNode("i", { class: "material-symbols-outlined text-purple-600 text-sm" }, "image", -1)),
                                    _createTextVNode(" " + _toDisplayString(_ctx.directT('ecommerce.createProduct.variationImage')), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_105, [
                                    (row.image)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
                                          _createElementVNode("div", _hoisted_107, [
                                            _createElementVNode("img", {
                                              src: row.image,
                                              alt: "Variation image",
                                              class: "w-full h-full object-cover"
                                            }, null, 8, _hoisted_108)
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_109, [
                                      _createElementVNode("div", _hoisted_110, [
                                        _createElementVNode("div", _hoisted_111, [
                                          _createElementVNode("div", _hoisted_112, [
                                            _cache[77] || (_cache[77] = _createElementVNode("div", { class: "w-8 h-8 bg-gradient-to-br from-[#5856d6] to-[#af52de] rounded-lg flex items-center justify-center" }, [
                                              _createElementVNode("i", { class: "material-symbols-outlined text-white text-sm" }, "cloud_upload")
                                            ], -1)),
                                            _createElementVNode("span", _hoisted_113, _toDisplayString(_ctx.directT('ecommerce.createProduct.uploadImage')), 1)
                                          ]),
                                          _createElementVNode("input", {
                                            type: "file",
                                            class: "absolute inset-0 w-full h-full opacity-0 cursor-pointer",
                                            onChange: ($event: any) => (_ctx.handleVariationImageUpload($event, groupIndex, rowIndex)),
                                            accept: "image/*"
                                          }, null, 40, _hoisted_114)
                                        ])
                                      ])
                                    ]),
                                    (group.rows.length > 1)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 1,
                                          type: "button",
                                          onClick: ($event: any) => (_ctx.removeVariationRow(groupIndex, rowIndex)),
                                          class: "flex-shrink-0 w-10 h-10 bg-red-50 dark:bg-red-900/20 hover:bg-red-100 dark:hover:bg-red-900/30 border border-red-200 dark:border-red-700/50 rounded-xl flex items-center justify-center transition-colors duration-200 group"
                                        }, _cache[78] || (_cache[78] = [
                                          _createElementVNode("i", { class: "material-symbols-outlined text-red-600 dark:text-red-400 text-sm group-hover:scale-110 transition-transform" }, "delete", -1)
                                        ]), 8, _hoisted_115))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ])
                            ]))
                          }), 128)),
                          _createElementVNode("button", {
                            type: "button",
                            onClick: ($event: any) => (_ctx.addVariationRow(groupIndex)),
                            class: "w-full flex items-center justify-center gap-2 px-4 py-3 bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-blue-900/20 dark:to-indigo-900/20 hover:from-blue-100 hover:to-indigo-100 dark:hover:from-blue-900/30 dark:hover:to-indigo-900/30 border-2 border-dashed border-blue-200 dark:border-blue-700/50 rounded-xl transition-all duration-200 shadow-sm hover:shadow-md group"
                          }, [
                            _cache[79] || (_cache[79] = _createElementVNode("div", { class: "w-6 h-6 bg-blue-500/10 dark:bg-blue-400/20 rounded-lg flex items-center justify-center group-hover:bg-blue-500/20 dark:group-hover:bg-blue-400/30 transition-colors" }, [
                              _createElementVNode("i", { class: "material-symbols-outlined text-blue-600 dark:text-blue-400 text-sm" }, "add")
                            ], -1)),
                            _createElementVNode("span", _hoisted_117, _toDisplayString(_ctx.directT('ecommerce.createProduct.addVariationRow')), 1)
                          ], 8, _hoisted_116)
                        ])
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.showCustomFields)
              ? (_openBlock(), _createElementBlock("div", _hoisted_118, [
                  _createElementVNode("div", _hoisted_119, [
                    _createElementVNode("div", _hoisted_120, [
                      _cache[80] || (_cache[80] = _createElementVNode("div", {
                        class: "w-10 h-10 rounded-xl flex items-center justify-center",
                        style: {"background":"linear-gradient(135deg, #5856d6 0%, #af52de 100%)"}
                      }, [
                        _createElementVNode("i", { class: "material-symbols-outlined text-white text-lg" }, "add_box")
                      ], -1)),
                      _createElementVNode("h3", _hoisted_121, _toDisplayString(_ctx.directT('ecommerce.createProduct.customFields')), 1)
                    ]),
                    _createElementVNode("button", {
                      onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.removeCustomFieldsCard && _ctx.removeCustomFieldsCard(...args))),
                      class: "w-10 h-10 bg-red-50 dark:bg-red-900/20 hover:bg-red-100 dark:hover:bg-red-900/30 border border-red-200 dark:border-red-700/50 rounded-xl flex items-center justify-center transition-colors duration-200 group"
                    }, _cache[81] || (_cache[81] = [
                      _createElementVNode("i", { class: "material-symbols-outlined text-red-600 dark:text-red-400 text-sm group-hover:scale-110 transition-transform" }, "delete", -1)
                    ]))
                  ]),
                  _createElementVNode("div", _hoisted_122, [
                    _createElementVNode("label", _hoisted_123, _toDisplayString(_ctx.directT('ecommerce.createProduct.fieldGroupName')), 1),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.editingCustomField.name) = $event)),
                      type: "text",
                      placeholder: _ctx.directT('ecommerce.createProduct.fieldGroupNamePlaceholder'),
                      class: "w-full px-4 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-green-500/20 focus:border-green-500 text-sm transition-all duration-200 shadow-sm hover:shadow-md text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400"
                    }, null, 8, _hoisted_124), [
                      [_vModelText, _ctx.editingCustomField.name]
                    ])
                  ]),
                  (!_ctx.selectedFieldType)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_125, [
                        _createElementVNode("h4", _hoisted_126, [
                          _cache[82] || (_cache[82] = _createElementVNode("i", { class: "material-symbols-outlined text-green-600 text-sm" }, "add", -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.directT('ecommerce.createProduct.addFields')), 1)
                        ]),
                        _createElementVNode("div", _hoisted_127, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fieldTypes, (fieldType) => {
                            return (_openBlock(), _createElementBlock("button", {
                              key: fieldType.type,
                              onClick: ($event: any) => (_ctx.selectFieldType(fieldType.type)),
                              class: "flex flex-col items-center gap-2 p-3 border-2 rounded-xl transition-all duration-200 group shadow-sm hover:shadow-md",
                              style: {"background-color":"#ffffff","border-color":"#d1d5db","color":"#374151"}
                            }, [
                              _createElementVNode("div", _hoisted_129, [
                                _createElementVNode("i", _hoisted_130, _toDisplayString(fieldType.icon), 1)
                              ]),
                              _createElementVNode("span", _hoisted_131, _toDisplayString(fieldType.label), 1)
                            ], 8, _hoisted_128))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.selectedFieldType)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_132, [
                        _createElementVNode("div", _hoisted_133, [
                          _createElementVNode("div", _hoisted_134, [
                            _createElementVNode("div", _hoisted_135, [
                              _createElementVNode("i", _hoisted_136, _toDisplayString(_ctx.fieldTypes.find(ft => ft.type === _ctx.selectedFieldType)?.icon || 'text_fields'), 1)
                            ]),
                            _createElementVNode("h4", _hoisted_137, _toDisplayString(_ctx.directT('ecommerce.createProduct.configureField')) + " - " + _toDisplayString(_ctx.fieldTypes.find(ft => ft.type === _ctx.selectedFieldType)?.label), 1)
                          ]),
                          _createElementVNode("button", {
                            onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.cancelFieldEdit && _ctx.cancelFieldEdit(...args))),
                            class: "w-8 h-8 rounded-lg flex items-center justify-center transition-colors group",
                            style: {"background-color":"#f3f4f6","color":"#6b7280"},
                            onMouseover: _cache[13] || (_cache[13] = ($event: any) => ($event.target.style.backgroundColor = '#e5e7eb')),
                            onMouseout: _cache[14] || (_cache[14] = ($event: any) => ($event.target.style.backgroundColor = '#f3f4f6'))
                          }, _cache[83] || (_cache[83] = [
                            _createElementVNode("i", { class: "material-symbols-outlined text-sm group-hover:scale-110 transition-transform" }, "close", -1)
                          ]), 32)
                        ]),
                        _createElementVNode("div", _hoisted_138, [
                          _createElementVNode("div", null, [
                            _createElementVNode("label", _hoisted_139, [
                              _createTextVNode(_toDisplayString(_ctx.directT('ecommerce.createProduct.fieldLabel')) + " ", 1),
                              _cache[84] || (_cache[84] = _createElementVNode("span", { class: "text-red-500" }, "*", -1))
                            ]),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.editingField.label) = $event)),
                              type: "text",
                              placeholder: _ctx.directT('ecommerce.createProduct.fieldLabelPlaceholder'),
                              class: "w-full px-4 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 text-sm transition-all duration-200 shadow-sm hover:shadow-md text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400"
                            }, null, 8, _hoisted_140), [
                              [_vModelText, _ctx.editingField.label]
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("label", _hoisted_141, _toDisplayString(_ctx.directT('ecommerce.createProduct.fieldPlaceholder')), 1),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.editingField.placeholder) = $event)),
                              type: "text",
                              placeholder: _ctx.directT('ecommerce.createProduct.fieldPlaceholderPlaceholder'),
                              class: "w-full px-4 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 text-sm transition-all duration-200 shadow-sm hover:shadow-md text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400"
                            }, null, 8, _hoisted_142), [
                              [_vModelText, _ctx.editingField.placeholder]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_143, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.editingField.required) = $event)),
                              type: "checkbox",
                              id: "fieldRequired",
                              class: "w-5 h-5 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                            }, null, 512), [
                              [_vModelCheckbox, _ctx.editingField.required]
                            ]),
                            _createElementVNode("label", _hoisted_144, _toDisplayString(_ctx.directT('ecommerce.createProduct.requiredField')), 1)
                          ]),
                          (_ctx.selectedFieldType === 'select' || _ctx.selectedFieldType === 'radio')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_145, [
                                _createElementVNode("label", _hoisted_146, _toDisplayString(_ctx.directT('ecommerce.createProduct.fieldOptions')), 1),
                                _createElementVNode("div", _hoisted_147, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editingField.options, (option, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: index,
                                      class: "flex items-center gap-2"
                                    }, [
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": ($event: any) => ((_ctx.editingField.options[index]) = $event),
                                        type: "text",
                                        placeholder: `${_ctx.directT('ecommerce.createProduct.option')} ${index + 1}`,
                                        class: "flex-1 px-3 py-2 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 text-sm text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400"
                                      }, null, 8, _hoisted_148), [
                                        [_vModelText, _ctx.editingField.options[index]]
                                      ]),
                                      _createElementVNode("button", {
                                        onClick: ($event: any) => (_ctx.removeFieldOption(index)),
                                        class: "w-8 h-8 rounded-lg flex items-center justify-center transition-colors group",
                                        style: {"background-color":"#fee2e2","color":"#dc2626"},
                                        onMouseover: _cache[18] || (_cache[18] = ($event: any) => ($event.target.style.backgroundColor = '#fecaca')),
                                        onMouseout: _cache[19] || (_cache[19] = ($event: any) => ($event.target.style.backgroundColor = '#fee2e2'))
                                      }, _cache[85] || (_cache[85] = [
                                        _createElementVNode("i", { class: "material-symbols-outlined text-sm group-hover:scale-110 transition-transform" }, "close", -1)
                                      ]), 40, _hoisted_149)
                                    ]))
                                  }), 128)),
                                  _createElementVNode("button", {
                                    type: "button",
                                    onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.addFieldOption && _ctx.addFieldOption(...args))),
                                    class: "w-full flex items-center justify-center gap-2 px-4 py-2 border-2 border-dashed rounded-lg transition-all duration-200 group",
                                    style: {"background-color":"#ffffff","border-color":"#d1d5db","color":"#6b7280"},
                                    onMouseover: _cache[21] || (_cache[21] = ($event: any) => {$event.target.style.backgroundColor = '#f9fafb'; $event.target.style.borderColor = '#9ca3af'}),
                                    onMouseout: _cache[22] || (_cache[22] = ($event: any) => {$event.target.style.backgroundColor = '#ffffff'; $event.target.style.borderColor = '#d1d5db'})
                                  }, [
                                    _cache[86] || (_cache[86] = _createElementVNode("i", { class: "material-symbols-outlined text-sm group-hover:scale-110 transition-transform" }, "add", -1)),
                                    _createElementVNode("span", _hoisted_150, _toDisplayString(_ctx.directT('ecommerce.createProduct.addOption')), 1)
                                  ], 32)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_151, [
                            _createElementVNode("button", {
                              type: "button",
                              onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.cancelFieldEdit && _ctx.cancelFieldEdit(...args))),
                              class: "flex items-center gap-2 px-6 py-3 rounded-xl transition-all duration-200 font-medium",
                              style: {"background-color":"#dc2626","color":"white"},
                              onMouseover: _cache[24] || (_cache[24] = ($event: any) => ($event.target.style.backgroundColor = '#b91c1c')),
                              onMouseout: _cache[25] || (_cache[25] = ($event: any) => ($event.target.style.backgroundColor = '#dc2626'))
                            }, [
                              _cache[87] || (_cache[87] = _createElementVNode("i", { class: "material-symbols-outlined text-sm" }, "close", -1)),
                              _createTextVNode(" " + _toDisplayString(_ctx.directT('ecommerce.createProduct.cancel')), 1)
                            ], 32),
                            _createElementVNode("button", {
                              type: "button",
                              onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.saveFieldDetails && _ctx.saveFieldDetails(...args))),
                              class: "flex items-center gap-2 px-6 py-3 rounded-xl transition-all duration-200 shadow-md hover:shadow-lg font-medium",
                              style: {"background":"linear-gradient(135deg, #5856d6 0%, #af52de 100%)","color":"white"},
                              onMouseover: _cache[27] || (_cache[27] = ($event: any) => ($event.target.style.background = 'linear-gradient(135deg, #4c46d6 0%, #9d47d4 100%)')),
                              onMouseout: _cache[28] || (_cache[28] = ($event: any) => ($event.target.style.background = 'linear-gradient(135deg, #5856d6 0%, #af52de 100%)'))
                            }, [
                              _cache[88] || (_cache[88] = _createElementVNode("i", { class: "material-symbols-outlined text-sm" }, "add", -1)),
                              _createTextVNode(" " + _toDisplayString(_ctx.directT('ecommerce.createProduct.addField')), 1)
                            ], 32)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.editingCustomField.fields.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_152, [
                        _createElementVNode("h4", _hoisted_153, [
                          _cache[89] || (_cache[89] = _createElementVNode("i", { class: "material-symbols-outlined text-blue-600 text-sm" }, "list", -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.directT('ecommerce.createProduct.selectedFields')) + " (" + _toDisplayString(_ctx.editingCustomField.fields.length) + ") ", 1)
                        ]),
                        _createElementVNode("div", _hoisted_154, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editingCustomField.fields, (field) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: field.id,
                              class: "bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-blue-900/20 dark:to-indigo-900/20 border border-blue-200 dark:border-blue-700/50 rounded-xl p-4"
                            }, [
                              _createElementVNode("div", _hoisted_155, [
                                _createElementVNode("div", _hoisted_156, [
                                  _createElementVNode("div", _hoisted_157, [
                                    _createElementVNode("i", _hoisted_158, _toDisplayString(_ctx.fieldTypes.find(ft => ft.type === field.type)?.icon || 'text_fields'), 1)
                                  ]),
                                  _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_159, _toDisplayString(field.label), 1),
                                    _createElementVNode("div", _hoisted_160, _toDisplayString(field.type) + _toDisplayString(field.required ? ` • ${_ctx.directT('ecommerce.createProduct.required')}` : ''), 1)
                                  ])
                                ]),
                                _createElementVNode("button", {
                                  onClick: ($event: any) => (_ctx.removeFieldFromGroup(field.id)),
                                  class: "w-8 h-8 rounded-lg flex items-center justify-center transition-colors group",
                                  style: {"background-color":"#fee2e2","color":"#dc2626"},
                                  onMouseover: _cache[29] || (_cache[29] = ($event: any) => ($event.target.style.backgroundColor = '#fecaca')),
                                  onMouseout: _cache[30] || (_cache[30] = ($event: any) => ($event.target.style.backgroundColor = '#fee2e2'))
                                }, _cache[90] || (_cache[90] = [
                                  _createElementVNode("i", { class: "material-symbols-outlined text-sm group-hover:scale-110 transition-transform" }, "close", -1)
                                ]), 40, _hoisted_161)
                              ])
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_162, [
            _createElementVNode("div", _hoisted_163, [
              _createElementVNode("div", _hoisted_164, [
                _cache[91] || (_cache[91] = _createElementVNode("div", { class: "w-10 h-10 bg-gradient-to-br from-[#5856d6] to-[#af52de] rounded-xl flex items-center justify-center" }, [
                  _createElementVNode("i", { class: "material-symbols-outlined text-white text-lg" }, "local_offer")
                ], -1)),
                _createElementVNode("h3", _hoisted_165, _toDisplayString(_ctx.directT('ecommerce.createProduct.tags')), 1)
              ]),
              _createElementVNode("div", _hoisted_166, [
                _createElementVNode("div", _hoisted_167, [
                  _createElementVNode("label", _hoisted_168, [
                    _cache[92] || (_cache[92] = _createElementVNode("i", { class: "material-symbols-outlined text-purple-600 text-sm" }, "sell", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.directT('ecommerce.createProduct.tags')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_169, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.tagsInput) = $event)),
                      placeholder: _ctx.directT('ecommerce.createProduct.tagsPlaceholder'),
                      class: "w-full px-4 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm bg-white/80 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400",
                      onKeydown: _cache[32] || (_cache[32] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.addTagOnEnter && _ctx.addTagOnEnter(...args)), ["prevent"]), ["enter"]))
                    }, null, 40, _hoisted_170), [
                      [_vModelText, _ctx.tagsInput]
                    ]),
                    _cache[93] || (_cache[93] = _createElementVNode("div", { class: "absolute right-3 top-1/2 -translate-y-1/2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined text-gray-400 text-sm" }, "add")
                    ], -1))
                  ]),
                  _createElementVNode("p", _hoisted_171, [
                    _cache[94] || (_cache[94] = _createElementVNode("i", { class: "material-symbols-outlined text-xs" }, "info", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.directT('ecommerce.createProduct.tagsHint') || 'הפרד תגיות בפסיקים'), 1)
                  ])
                ]),
                (_ctx.parsedTags.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_172, [
                      _createElementVNode("h4", _hoisted_173, [
                        _cache[95] || (_cache[95] = _createElementVNode("i", { class: "material-symbols-outlined text-sm" }, "label", -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.directT('ecommerce.createProduct.selectedTags') || 'תגיות נבחרות'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_174, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parsedTags, (tag, index) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: index,
                            class: "inline-flex items-center gap-1 px-3 py-1.5 bg-gradient-to-r from-purple-100 to-blue-100 dark:from-purple-900/30 dark:to-blue-900/30 text-purple-700 dark:text-purple-300 text-xs font-medium rounded-full border border-purple-200 dark:border-purple-700/50 shadow-sm cursor-pointer hover:bg-gradient-to-r hover:from-red-100 hover:to-red-200 dark:hover:from-red-900/30 dark:hover:to-red-800/30 hover:text-red-700 dark:hover:text-red-300 hover:border-red-200 dark:hover:border-red-700/50 transition-all duration-200",
                            onClick: ($event: any) => (_ctx.removeTag(tag)),
                            title: _ctx.directT('ecommerce.createProduct.clickToRemoveTag') || 'לחץ למחיקת התגית'
                          }, [
                            _cache[96] || (_cache[96] = _createElementVNode("i", { class: "material-symbols-outlined text-xs" }, "tag", -1)),
                            _createTextVNode(" " + _toDisplayString(tag) + " ", 1),
                            _cache[97] || (_cache[97] = _createElementVNode("i", { class: "material-symbols-outlined text-xs opacity-50 hover:opacity-100" }, "close", -1))
                          ], 8, _hoisted_175))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_176, [
              _cache[101] || (_cache[101] = _createElementVNode("div", { class: "flex items-center gap-3 mb-6" }, [
                _createElementVNode("div", { class: "w-10 h-10 bg-gradient-to-br from-[#5856d6] to-[#af52de] rounded-xl flex items-center justify-center" }, [
                  _createElementVNode("i", { class: "material-symbols-outlined text-white text-lg" }, "settings")
                ]),
                _createElementVNode("h3", { class: "text-lg font-bold text-gray-900 dark:text-white leading-none h-10 flex items-center" }, " Actions ")
              ], -1)),
              _createElementVNode("div", _hoisted_177, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[33] || (_cache[33] = 
//@ts-ignore
(...args) => (_ctx.addVariation && _ctx.addVariation(...args))),
                  class: "w-full flex items-center gap-3 px-4 py-3 bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-blue-900/20 dark:to-indigo-900/20 hover:from-blue-100 hover:to-indigo-100 dark:hover:from-blue-900/30 dark:hover:to-indigo-900/30 border border-blue-200 dark:border-blue-700/50 rounded-xl transition-all duration-200 shadow-sm hover:shadow-md group"
                }, [
                  _cache[98] || (_cache[98] = _createElementVNode("div", { class: "w-8 h-8 bg-blue-500/10 dark:bg-blue-400/20 rounded-lg flex items-center justify-center group-hover:bg-blue-500/20 dark:group-hover:bg-blue-400/30 transition-colors" }, [
                    _createElementVNode("i", { class: "material-symbols-outlined text-blue-600 dark:text-blue-400 text-sm" }, "tune")
                  ], -1)),
                  _createElementVNode("span", _hoisted_178, _toDisplayString(_ctx.directT('ecommerce.createProduct.addVariation')), 1)
                ]),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[34] || (_cache[34] = 
//@ts-ignore
(...args) => (_ctx.addCustomFields && _ctx.addCustomFields(...args))),
                  class: "w-full flex items-center gap-3 px-4 py-3 bg-gradient-to-r from-green-50 to-emerald-50 dark:from-green-900/20 dark:to-emerald-900/20 hover:from-green-100 hover:to-emerald-100 dark:hover:from-green-900/30 dark:hover:to-emerald-900/30 border border-green-200 dark:border-green-700/50 rounded-xl transition-all duration-200 shadow-sm hover:shadow-md group"
                }, [
                  _cache[99] || (_cache[99] = _createElementVNode("div", { class: "w-8 h-8 bg-green-500/10 dark:bg-green-400/20 rounded-lg flex items-center justify-center group-hover:bg-green-500/20 dark:group-hover:bg-green-400/30 transition-colors" }, [
                    _createElementVNode("i", { class: "material-symbols-outlined text-green-600 dark:text-green-400 text-sm" }, "add_box")
                  ], -1)),
                  _createElementVNode("span", _hoisted_179, _toDisplayString(_ctx.directT('ecommerce.createProduct.addCustomFields')), 1)
                ]),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[35] || (_cache[35] = 
//@ts-ignore
(...args) => (_ctx.addProduct && _ctx.addProduct(...args))),
                  class: "w-full flex items-center gap-3 px-4 py-3 bg-gradient-to-r from-purple-50 to-pink-50 dark:from-purple-900/20 dark:to-pink-900/20 hover:from-purple-100 hover:to-pink-100 dark:hover:from-purple-900/30 dark:hover:to-pink-900/30 border border-purple-200 dark:border-purple-700/50 rounded-xl transition-all duration-200 shadow-sm hover:shadow-md group"
                }, [
                  _cache[100] || (_cache[100] = _createElementVNode("div", { class: "w-8 h-8 bg-purple-500/10 dark:bg-purple-400/20 rounded-lg flex items-center justify-center group-hover:bg-purple-500/20 dark:group-hover:bg-purple-400/30 transition-colors" }, [
                    _createElementVNode("i", { class: "material-symbols-outlined text-purple-600 dark:text-purple-400 text-sm" }, "add_circle")
                  ], -1)),
                  _createElementVNode("span", _hoisted_180, _toDisplayString(_ctx.directT('ecommerce.createProduct.addProduct')), 1)
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 8, _hoisted_1))
}